import React, { useEffect, ReactNode } from "react";
import { LuArrowRight } from "react-icons/lu";
import { Link } from "react-router-dom";
import { APP_ENVIRONMENT, APP_VERSION } from "../../../api-services/Process";
import { Logo, VesselImage } from "../../../assets/img";

type HeadProps = { title: string };
type LayoutProps = { children?: ReactNode; title: string };

const Head: React.FC<HeadProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

const AuthLayout = ({ children, title }: LayoutProps) => (
  <>
    <Head title={title} />

    <main className="flex h-[100vh]">
      <section
        className="hidden xl:flex w-3/5 bg-gray-800 flex items-center justify-center bg-cover bg-[50%_100%]"
        style={{ backgroundImage: `url(${VesselImage})` }}
      ></section>

      <section className="w-full bg-white md:bg-slate-100 xl:bg-white xl:w-2/5 flex flex-col shadow-3xl">
        <div className="justify-center flex w-full mt-5 md:bg-white md:justify-between md:px-12 md:items-center md:border-b md:py-3 md:mt-0 md:shadow xl:shadow-none xl:border-none xl:justify-center">
          <img
            alt="company logo"
            src={Logo}
            className="w-[70px] md:w-[55px] xl:w-[65px] flex-col"
          />

          <Link
            to="/how-it-works"
            className="xl:hidden md:flex items-center text-blue-700 font-medium"
          >
            <span>How it Works</span>
            <LuArrowRight />
          </Link>
        </div>

        <h2 className="2xl:pt-16 md:pt-12 xl:pt-6 pt-6 font-medium flex-col text-2xl text-black text-center">
          {title}
        </h2>

        <div className="2xl:px-24">{children}</div>

        <footer className="flex justify-center gap-5 py-2 text-gray-600 text-[10px]">
          <div>
            {APP_ENVIRONMENT} v-{APP_VERSION}
          </div>
          <div>
            totalenergies mvip &copy;
            {new Date().getFullYear() === 2024 ? "" : "2024 - "}{" "}
            {new Date().getFullYear()}
          </div>
        </footer>

        <div className="overflow-hidden fixed bottom-0 mt-6 flex-col waveAnimation xl:w-2/5">
          <svg viewBox="0 0 700 150" preserveAspectRatio="none">
            <path
              className="w1 waveTop"
              d="M-8.74,71.55 C289.78,255.11 349.60,4.47 505.36,34.05 L500.00,150.00 L0.00,150.00 Z"
            />
            <path
              className="w2 waveMiddle"
              d="M-23.42,125.83 C187.63,45.89 299.38,57.73 526.80,123.86 L500.00,150.00 L0.00,150.00 Z"
            />
            <path
              className="w3 waveBottom"
              d="M-23.42,125.83 C172.96,-152.44 217.55,183.06 504.22,55.77 L500.00,150.00 L0.00,150.00 Z"
            />
          </svg>
        </div>
      </section>
    </main>
  </>
);

export default AuthLayout;
